(function () {
    angular.module('tmx-app').directive('dynamicPage', dynamicPage);

    function dynamicPage() {
        var directive = {};
        directive.scope = {
            form: '=',
            page: '=',
            showErrors: '=',
            onChange: '&',
            showTitle: '@',
            showStaticTabs: '@',
            issueType: '=',
            disabled: "=",
            staticTab: "=",
            comment: "=",
            status: "=",
            dropDown: "=",
            isStateInfo: "=",
            applicationId: '=',
            applicationData: '=',
            documentWatermark: '=',
            signatureImages: '=',
            EnglishTnC: '&',
            UrduTnC: '&'
        };
        directive.replace = true;
        directive.restrict = 'E';
        directive.templateUrl = 'common/directives/dynamicpage/dynamicpage.html';
        directive.controller = ["$scope", "$stateParams", "$filter", "tmxResource", "$mdDialog", "lookupService", "LoanApplicationService", "tmxUtility", "dynamicFormService", "ToastService", "cacheStore", "TMX_FINANCE_CONSTANTS", "BroadcastService", "TmxDialogService", pageCtrl];
        directive.controllerAs = "pageCtrl";
        return directive;
    }
    var exists;

    function pageCtrl($scope, $stateParams, $filter, tmxResource, $mdDialog, lookupService, LoanApplicationService, tmxUtility, dynamicFormService, ToastService, cacheStore, TMX_FINANCE_CONSTANTS, BroadcastService, TmxDialogService) {

        //#region  Variables Initialization
        var vm = this;
        vm.id = $stateParams.Id;
        exists = tmxUtility.exists;
        vm.formatDate = tmxUtility.formatDateForCompany;
        vm.dialogForm = $scope.form;
        vm.map = $scope.page.fieldMap.primaryKey;
        vm.checkPermission = tmxUtility.checkPermission;
        vm.checkTabPermission = tmxUtility.checkTabPermission;
        var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
        $scope.page.selectedTab = 1;
        $scope.page.selectedTabIndex = 0;
        var culture = localStorage.getItem('culture');
        vm.direction = culture == "ar" ? "rtl" : "ltr";
        var staticPages = ['Guarantors', 'CheckEligibility', 'NadraVerisys', 'LocationTracking', 'ECIB Details', 'BVS', 'ETB'];
        var guarantorPageDefaultValue = 'Guarantors';
        var LoggedInUserConfigurations = cacheStore.get("Configurations");
        vm.loginTenantName = "";
        var tenants = TMX_FINANCE_CONSTANTS.TENANTS;
        vm.checklist = [];
        vm.customersList = [];
        vm.IDsList = [];
        var imagePreviewPopups = [];
        vm.selectedFromExistingClient = [];
        var guarantorTabSchema;
        vm.ClientTypeLookups = lookupService.getLocalLookupsByType(lkupType.CLIENT_TYPE);
        console.log(vm.ClientTypeLookups);
        vm.ClientTypeLkp;
        vm.ClientTypeChange = ClientTypeChange;
        vm.TimeStampFormatting = tmxUtility.formatDateTimeForCompany;
        vm.formatDate = tmxUtility.formatDateForCompany;
        vm.productTypeCode = 'L'; // L for Loan, A for Account , T for Trade

        // ---------Guarantor Related Variables
        var IdlookupType = "";
        vm.checkUniqueClients = checkUniqueClients;
        vm.TranslateModelValues = TranslateModelValues;
        vm.isGuarantorDynamic = false;
        var egyptHiddenValue = TMX_FINANCE_CONSTANTS.LOOKUP_HV.egyptHiddenValue;
        vm.guarantorAttach = "";
        var hasGuarantorTabAsChild = false; // To check and run logic only for parent dynamic page of guarantor and not all child pages.
        var tempGuarantor = null;
        var GuarantorETBMandatory = false;
        var disableAddBtn = false;
        //#endregion

        //#region ========== Dynamic Form Logic ============================================

        vm.isValid = function () {
            return $scope.page.pageData.isValid;
        }


        vm.isTimeStamp = function (field) {
            if (field.type == "timestamp") {
                return true
            }
            return false;
        }
        vm.isTextBox = function (field) {

            if ((field.type == "text" || field.type == "alphanumeric" || field.type == "number" || field.type == "rangenumber" || field.type == "numeric" || field.type == "textarea" || field.type == "cnic" || field.type == "phone" || field.type == "email" || field.type == "alphabet" || field.type == "alpha" || field.type == "amount" || field.type == "locationcapture" || field.type == "addressmap") && exists(field.form_name)) {
                //  if(field.type=="number"){
                // 	field.type="text";					
                // } else 


                if (field.type == "numeric") {
                    field.type = "text";
                    field.PatternName = 'Pattern_Number';
                    field.pattern = $filter('translate')("Pattern_Number");
                }
                else if (field.type == "alphabet") {
                    field.type = "text";
                    field.PatternName = 'Pattern_Characters_Or_Aplha';
                    field.pattern = $filter('translate')("Pattern_Characters_Or_Aplha");
                }
                else if (field.type == "alpha") {
                    field.type = "text";
                    field.PatternName = 'Pattern_Alpha_WithoutSpace';
                    field.pattern = $filter('translate')("Pattern_Alpha_WithoutSpace");
                }

                // if(field.name=="FamilyIdentifier" || field.name=="OtherAssetDetails"){
                // 	field.type="alphanumeric";
                // }

                return true;
            }
            return false;

        }
        vm.onSelect = function (tab) {
            $scope.page.selectedTab = tab.id;
        };
        vm.isHeader = function (field) {
            return (field.type == "header");
        }
        vm.isTextArea = function (field) {
            return (field.type == "textarea") && exists(field.form_name && false); //from now on textbox represents text area (4/21/2016)
        }
        vm.isCheckbox = function (field) {
            return (field.type == "checkbox") && exists(field.form_name);
        }
        vm.isFileCheckbox = function (field) {
            return (field.type == "checkbox_file") && exists(field.form_name);
        }
        vm.isSelect = function (field) {
            return (field.type == "select") && exists(field.form_name);
        }
        vm.isTreeView = function (field) {
            return (field.type == "treeview") && exists(field.form_name);
        }
        vm.isDate = function (field) {
            return (field.type == "date") && exists(field.form_name);
        }
        vm.isTable = function (field) {
            return (field.type == "table") && exists(field.form_name);
        }
        vm.isQuestion = function (field) {
            return (field.type == 'question')
        }
        vm.isDummy = function (field) {
            return field.type == "dummy";
        }
        vm.isECIB = function (field) {

            return field.type == "ecib" && exists(field.form_name);
        }
        vm.isCNIC = function (field) {
            return field.type == "cnic" && field.getFromServer && exists(field.form_name);
        }

        vm.isHTML = function (field) {
            return field.type == "htmlarea";
        }

        vm.isSignature = function (field) {
            return field.type == "signature" && exists(field.form_name);
        }
        vm.isFingerprint = function (field) {
            return field.type == "fingerprint" && exists(field.form_name);
        }
        vm.isHyperLink = function (field) {
            return field.type == "hyperlink";
        }
        vm.showInvalidTabs = function () {
            return $scope.showErrors && $scope.page.invalidTabs.size > 0;
        }
        vm.onImageClick = function (value, field) {
            vm.previewImageUrl = value;
            vm.previewImageField = field;
            vm.openImageWindow();
        }

        vm.openImageWindow = function () {
            //var html = '<img style="width: 100%;" src="'+vm.previewImageUrl+'" />';
            //var uri = "data:text/html," + encodeURIComponent(html);
            var images = [];
            var notAllowedFormats = ['.tiff', '.tif', 'data:image/tiff;base64'];
            var previewIndex = 0;
            for (var i = 0; i < vm.checklist.length; i++) {
                var value = vm.checklist[i].attachment ? vm.checklist[i].attachment : vm.checklist[i].value;
                if (value && !value.includes(notAllowedFormats[0]) && !value.includes(notAllowedFormats[1]) && !value.includes(notAllowedFormats[2])) {
                    if (vm.checklist[i].id == vm.previewImageField.id) {
                        previewIndex = images.length;
                    }
                    var image = {
                        src: value,
                        label: vm.checklist[i].label
                    }
                    images.push(image);
                }
            }
            localStorage.setItem('imagePreview', JSON.stringify(images));
            //var html = vm.previewImageUrl;
            // + '&title=' + encodeURIComponent($scope.page.fieldMap.primaryKey.tf146.value)
            var uri = "common/directives/dynamicpage/imagePreview.html?img=" + encodeURIComponent(previewIndex);
            var newwindow = window.open(uri, 'Image Preview ' + imagePreviewPopups.length, 'height=900,width=900');
            imagePreviewPopups.push(newwindow);
        }
        vm.onChange = function (value, scope) {
            //update field's validity

            var field = scope.dynamicField;

            field.updateValue(value, $scope.page.fieldMap.primaryKey, false, $scope);

            //trigger page's onchange if any
            if (angular.isFunction($scope.onChange())) {
                $scope.onChange()(value, scope);
            }
        }
        function ClientTypeChange(clientType) {
            //vm.isCompanyClient = lookupService.getHiddenValueById(clientType) == "1";
        }
        vm.isInvalid = function () { }
        vm.onStart = function () { }
        vm.onSuccess = function () { }
        vm.onAlreadyExist = function () { }
        vm.isDynamicPage = function (tab) {
            return staticPages.indexOf(tab.defaultValue) > -1 ? false : true;
        }


        $scope.getLookupVisibleValue = function (lookupId) {
            var lookup = lookupService.getLookupById(lookupId);
            if (exists(lookup)) {
                return lookup.VisibleValue;
            }
            return "";
        }

        $scope.evalFormula = function () {
            return ""; /*evalFormula(field,$scope.page.fieldMap.primaryKey);*/
        }


        vm.calculateAge = function (dateString) {

            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        vm.copyGrid = function (src, des) {
            BroadcastService.publish("onGridDataFetch", { src: src, des: des });
        }

        vm.checklist.sort(function (a, b) {
            if (a.seq < b.seq)
                return -1;
            if (a.seq > b.seq)
                return 1;
            return 0;
        });

        //#endregion ========================================================================


        //#region =========== Guarantor Logic =============================================

        function canDeleteGuarantor() {
            if (tenants.VITAS == vm.loginTenantName) {
                let disAllowedStatuses = ['SendBackToFO', 'SendBackToTL'];
                if (exists(vm.applicationStatus) && disAllowedStatuses.includes(vm.applicationStatus.HiddenValue)) {
                    return false;
                }
            }
            return true;
        }

        vm.deleteGuarantor = function (index) {
            if (!canDeleteGuarantor()) {
                ToastService.showCustomToast("error", $filter('translate')("ActionNotAllowed"));
                return;
            }
            vm.guarantorData.splice(index, 1);
        }

        vm.changeGuarantorStatus = function (guarantorObj) {
            TmxDialogService.showConfirmDialog("Confirmation", "Are you sure you want to change the status?", function () {
                guarantorObj.ActiveFlag = !guarantorObj.ActiveFlag
            });
        }

        vm.addDetail = function () {
            if (!disableAddBtn)
                vm.viewDetail(-1, {}, 'true', 'false');
        }

        vm.viewCustomerDetail = function (ClientID) {
            if(!tmxUtility.exists(ClientID)){
                ToastService.showCustomToast("default", $filter('translate')("SelectValidRecordMessage"));
                return;
            }
            var dataForGuarantorDialog = "";
            LoanApplicationService.fetchExistingCustomer(ClientID).then(function (response) {
                if (Array.isArray(response.data)) {
                    if (tenants.VITAS == vm.loginTenantName) {
                        dataForGuarantorDialog = vm.customerToGuarantorMappingForDynamic(response.data[0]);
                    }
                    if (tenants.VITAS_EG == vm.loginTenantName) {
                        dataForGuarantorDialog = vm.customerToGuarantorMapping(response.data[0]);
                    }
                    if (vm.loginTenantName == tenants.VITAS_LEB) {
                        dataForGuarantorDialog = vm.customerToGuarantorMappingLeb(response.data[0]);
                    }
                    vm.viewDetail(-1, dataForGuarantorDialog, 'true', ClientID);
                }
            })
        }

        vm.viewETBGuarantorDetail = function (index) {
            var dataForGuarantorDialog = "";
            if (exists(vm.customerMasterList)) {
                if (vm.isSambaTenant) {
                    dataForGuarantorDialog = vm.customerToGuarantorMappingSamba(vm.customerMasterList[index]);
                }
                else { // Else case is for ubank for now.
                    dataForGuarantorDialog = vm.customerToGuarantorMappingUbank(vm.customerMasterList[0]);
                }
                vm.viewDetail(-1, dataForGuarantorDialog, 'true');
            }


        }

        vm.customerToGuarantorMappingUbank = function (model) {
            if (exists(model)) {
                var TmxLoanApplicationToGuarantorMapping = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = model.TmxCustomerDetail[0].TmxPerson;

                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerExistingLoan = model.TmxCustomerExistingLoan;

                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.NationalIdentifierValue = vm.idvalue;

                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.ETBFlag = model.ETBFlag;

                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerExistingLoan = model.TmxCustomerExistingLoan;


                Object.keys(model).forEach(function (item) {
                    if (Object.prototype.toString.call(model[item]) != '[object Object]' && Object.prototype.toString.call(model[item]) != '[object Array]' && model[item] != null) {
                        TmxLoanApplicationToGuarantorMapping.TmxGuarantor[item] = model[item];
                    }
                })

                return TmxLoanApplicationToGuarantorMapping;
            }
            else {
                return "";
            }
        }

        vm.customerToGuarantorMappingSamba = function (model) {
            if (exists(model)) {
                var TmxLoanApplicationToGuarantorMapping = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = model.TmxCustomerDetail[0].TmxPerson;

                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerIntroducer = model.TmxCustomerIntroducer;
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerOtherAccounts = model.TmxCustomerOtherAccounts;
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerFinancialProfile = model.TmxCustomerFinancialProfile;
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerBankingDetails = model.TmxCustomerBankingDetails;
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxAccountKin = model.TmxAccountKin;
                Object.keys(model).forEach(function (item) {
                    if (Object.prototype.toString.call(model[item]) != '[object Object]' && Object.prototype.toString.call(model[item]) != '[object Array]' && model[item] != null) {
                        TmxLoanApplicationToGuarantorMapping.TmxGuarantor[item] = model[item];
                    }
                })

                return TmxLoanApplicationToGuarantorMapping;
            }
            else {
                return "";
            }
        }

        vm.customerToGuarantorMappingLeb = function (model) {
            if (exists(model)) {
                var TmxLoanApplicationToGuarantorMapping = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = {};
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = model.TmxCustomerDetail[0].TmxPerson;

                Object.keys(model).forEach(function (item) {
                    if (Object.prototype.toString.call(model[item]) != '[object Object]' && Object.prototype.toString.call(model[item]) != '[object Array]' && model[item] != null) {
                        TmxLoanApplicationToGuarantorMapping.TmxGuarantor[item] = model[item];
                    }
                })

                return TmxLoanApplicationToGuarantorMapping;
            }
            else {
                return "";
            }
        }


        vm.customerToGuarantorMapping = function (model) {
            var TmxLoanApplicationToGuarantorMapping = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = model.TmxCustomerDetail[0].TmxPerson;
            if (!exists(TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping)) {
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping = [{}];
            }

            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.ExistingGuarantor = 8;
            if (model.TmxCustomerExistingLoan) {
                if (model.TmxCustomerExistingLoan[0]) {
                    TmxLoanApplicationToGuarantorMapping.TmxGuarantor.LoanStatus = model.TmxCustomerExistingLoan[0].LoanStatus;
                    TmxLoanApplicationToGuarantorMapping.TmxGuarantor.LastLoanAmount = model.TmxCustomerExistingLoan[0].LastLoanAmount;
                    TmxLoanApplicationToGuarantorMapping.TmxGuarantor.OldOutstandingBalance = model.TmxCustomerExistingLoan[0].OutstandingBalance;
                    // TmxLoanApplicationToGuarantorMapping.TmxGuarantor.LatePaymentCount=model.TmxCustomerExistingLoan[0].LatePaymentCount;
                    TmxLoanApplicationToGuarantorMapping.TmxGuarantor.DelayInDays = model.TmxCustomerExistingLoan[0].DelayInDays;

                }
            }
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.CustomerCode = model.CustomerCode;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.PersonFatherName = model.FatherFirstName;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.PersonMotherName = model.MotherName;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.PersonGrandFatherName = model.TmxCustomerDetail[0].TmxPerson.PersonMiddleName;
            if (model.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth) {
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.PersonAge = vm.calculateAge(model.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth);
            }
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.PersonSpouseName = model.TmxCustomerDetail[0].TmxPerson.SpouseFirstName;
            //TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.PersonEmploymentStatusLkp=model.TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].StatusLkp;
            //TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].StatusLkp=model.TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].StatusLkp;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].OfficeTelephoneNumber1 = model.TmxCustomerDetail[0].TmxPerson.OfficeTelephoneNumber1;

            var documentTypeAndNumber = model.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                return item.NationalIdTypeLkp == 2;
            })[0];
            if (documentTypeAndNumber) {
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.IDDocumentType = documentTypeAndNumber.DocumentType;
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.IDDocumentNumber = documentTypeAndNumber.NationalIdentifierValue;
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.IdExpiryDate = documentTypeAndNumber.NationalIdExpiryDate;
            }
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine1 = model.HomeAddress;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine2 = model.Region;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine3 = model.City;
            var civilRegNumber = model.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                return item.NationalIdTypeLkp == 6;
            })[0];
            //console.log(civilRegNumber);
            if (civilRegNumber) {
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.CivilRegistrationNumber = civilRegNumber.NationalIdentifierValue;
            }
            var nationalId = model.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                return item.NationalIdTypeLkp == 5;
            })[0];
            //console.log(nationalId);
            if (nationalId) {
                TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[0].NationalIdentifierValue = nationalId.NationalIdentifierValue;
            }
            //TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[0].NationalIdExpiryDate=nationalId.NationalIdExpiryDate;
            //console.log(civilRegNumber);
            return TmxLoanApplicationToGuarantorMapping;
        }

        vm.customerToGuarantorMappingForDynamic = function (model) {
            var TmxLoanApplicationToGuarantorMapping = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = {};
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor = model;
            TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxPerson = model.TmxCustomerDetail[0].TmxPerson;
            delete TmxLoanApplicationToGuarantorMapping.TmxGuarantor.TmxCustomerDetail;
            delete TmxLoanApplicationToGuarantorMapping.TmxGuarantor.CustomerMasterId;
            
            return TmxLoanApplicationToGuarantorMapping;
        }

        vm.showClient = function (cliendId) {

            if (vm.selectedFromExistingClient.indexOf(cliendId) > -1) {
                return false;
            }
            else {
                return true;
            }
        }
        vm.viewDetail = function (index, data, add, ClientID) {

            var guarantorData = {};
            var showAddButton = false;
            ({ guarantorData, showAddButton } = PrepareGuarantorData(index, guarantorData, data, add));

           
            if (vm.isGuarantorDynamic == true) {
                showDynamicGuarantor(index, guarantorData, showAddButton, ClientID);
            }
            else {
                showStaticGuarantorTab(guarantorData, showAddButton, ClientID);
            }
        }

        vm.removeIdentificationDocumentNumber = function (index) {
            vm.IDsList.splice(index, 1);
        }

        vm.addIdentificationDocumentNumber = function () {
            vm.IDsList.push({
                "ID": "",
                "IdentificationDocumentTypeID": "",
                "IdentificationDocumentNumber": "",
                "DateofIssuance": "",
                "ExpiryDate": "",
                "rowState": "Added",
                "UserId": vm.UserId
            })
        }

        function showDynamicGuarantor(index, guarantorData, showAddButton, ClientID) {
            // var selectedTmxGuarantor = vm.guarantorData[index].TmxGuarantor; 
            var selectedTmxGuarantor = guarantorData.TmxGuarantor;
            vm.applicationToGuarantorMappingData = guarantorData;
            $mdDialog.show({
                controller: 'GuarantorDetailDynamicDialogController',
                templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/dynamic-guarantor-dialog.html',
                parent: angular.element(document.body),
                locals: {
                    selectedGuarantor: selectedTmxGuarantor,
                    showAddButton: showAddButton,
                    privileges: { edit: vm.guarantorTabEditPrivilege, delete: vm.guarantorTabDeletePrivilege, viewOnly: $scope.page.istabDisabled },
                    pageSchema: guarantorTabSchema,
                    pageFieldMap: $scope.page.fieldMap,
                    productTypeCode: vm.productTypeCode
                },
                clickOutsideToClose: false,
                multiple: true,
                fullscreen: true,
            }).then(dialogCloseSuccessCallback, dialogCloseErrorCallback);

            // anonymous functions wont work here because we want to access the calling function's arguments. therefore using closures

            function dialogCloseSuccessCallback(returnData) {
                if (!tmxUtility.exists(returnData)) {
                    if (index > -1) {
                        vm.guarantorData[index] = tmxUtility.copy(tempGuarantor);
                    }
                    return;
                }
                guarantorData.TmxGuarantor = returnData;
                if (showAddButton) {
                    guarantorData.ActiveFlag = guarantorData.ActiveFlag ? guarantorData.ActiveFlag : 1;
                    vm.guarantorData.push(guarantorData);
                    if (ClientID) {
                        vm.selectedFromExistingClient.push(ClientID);
                    }
                }
            }
            function dialogCloseErrorCallback(returnData) {
                if (!tmxUtility.exists(returnData)) {
                    if (index > -1) {
                        vm.guarantorData[index] = tmxUtility.copy(tempGuarantor);
                    }
                    return;
                }
            }
        }

        function showStaticGuarantorTab(guarantorData, showAddButton, ClientID) {
            $mdDialog.show({
                controller: 'GuarantorDetailDialogController',
                controllerAs: 'GuarantorDetailDialogController',
                locals: {
                    guarantorData: guarantorData,
                    showAddButton: showAddButton,
                    ClientID: ClientID,
                    guarantorTabEditPrivilege: vm.guarantorTabEditPrivilege,
                    guarantorTabDeletePrivilege: vm.guarantorTabDeletePrivilege,
                    RoleId: exists(vm.applicationData.TmxUserRoleMapping) ? vm.applicationData.TmxUserRoleMapping[0].RoleId : 0
                },
                templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/view-guarantor-detail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: $scope.customFullscreen,
            })
                .then(function (responseData) {
                    if (responseData) {
                        responseData.guarantorData.ActiveFlag = responseData.guarantorData.ActiveFlag ? responseData.guarantorData.ActiveFlag : 1;
                        vm.guarantorData.push(responseData.guarantorData);
                        if (responseData.ClientID) {
                            vm.selectedFromExistingClient.push(responseData.ClientID);
                        }
                        if (vm.idvalue) {
                            var length = vm.guarantorData.length - 1;
                            if (!exists(vm.guarantorData[length].TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[0])) {
                                vm.guarantorData[length].TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[0] = {};
                            }
                            vm.guarantorData[length].TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[0].NationalIdTypeLkp = 1;
                            vm.guarantorData[length].TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[0].NationalIdentifierValue = vm.idvalue;
                            // vm.guarantorData[length].TmxGuarantor.NationalIdTypeLkp = 1;
                            vm.guarantorData[length].TmxGuarantor.NationalIdentifierValue = vm.idvalue;
                        }
                    }
                    else {
                        if (vm.loginTenantName == tenants.UBANK) {
                            $scope.applicationData.TmxLoanAppToGuarantorMpg = vm.guarantorData;
                        }
                        else {
                            $scope.applicationData.TmxLoanApplicationToGuarantorMapping = vm.guarantorData;
                        }
                    }
                }, function () {
                });
        }

        function PrepareGuarantorData(index, guarantorData, data, add) {
            var showAddButton = false;
            applicationDataInitialize();
            if (index > -1) {
                guarantorData = vm.guarantorData[index];
                showAddButton = false;
            }
            else if (data && Object.keys(data).length) {
                guarantorData = data;
                showAddButton = true;
            }

            if (add) {
                showAddButton = true;
            }
            tempGuarantor = tmxUtility.copy(guarantorData);
            if (guarantorData.TmxGuarantor == null) {
                guarantorData.TmxGuarantor = {};
            }
            if (guarantorData.TmxGuarantor.TmxPerson == null) {
                guarantorData.TmxGuarantor.TmxPerson = {};
            }
            if (guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier == null) {
                guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier = [];
            }
            if (guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail == null) {
                guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail = [];
            }
            if (guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping == null || guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping.length < 1) {
                guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping = [{}];
            }

            if (guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress == null) {
                guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress = {};
            }

            if (guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact == null) {
                guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact = [];
            }
            if (guarantorData.TmxGuarantor.TmxPerson.TmxPersonAddressContact == null) {
                guarantorData.TmxGuarantor.TmxPerson.TmxPersonAddressContact = [];
            }
            if (guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail == null) {
                guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail = [];
            }
            if (guarantorData.TmxGuarantor.TmxGuarantorBankDetail == null) {
                guarantorData.TmxGuarantor.TmxGuarantorBankDetail = [];
            }
            if (guarantorData.TmxGuarantor.TmxGuarantorLoanDetail == null) {
                guarantorData.TmxGuarantor.TmxGuarantorLoanDetail = [];
            }
            if (guarantorData.TmxGuarantor.TmxGuarantorChecklist == null) {
                guarantorData.TmxGuarantor.TmxGuarantorChecklist = [];
            }
            var InstallmentAmount = $scope.page.fieldMap.all.filter(function (item) { return item.form_name == 'TmxLoanApplication_InstallmentAmount'; });
            guarantorData.InstallmentAmount = InstallmentAmount ? (InstallmentAmount.length > 0 ? InstallmentAmount[0].value : 0) : 0;
            //Setting Ofac cleared to Yes
            if (!exists(guarantorData.TmxGuarantor.OFACClearedUdf)) {
                guarantorData.TmxGuarantor.OFACClearedUdf = egyptHiddenValue.ofacClearedYes;
            }
            if (!data || Object.keys(data).length == 0) {
                setGuarantorPrepopulatedData(guarantorData);
            }
            if(add){
                if (vm.loginTenantName == tenants.VITAS_LEB) {
                    guarantorData.TmxGuarantor.negcustomer = vm.negcustomer;
                    guarantorData.TmxGuarantor.ReasonsList = vm.reasonsList;
    
                }
            }

            return { guarantorData, showAddButton };
        }

        function setGuarantorPrepopulatedData(guarantorData) {
            if (vm.loginTenantName == tenants.VITAS_LEB) {
                // Map filled object in static form into the dialog
                var lebVmToGuarantorMapping = LoanApplicationService.lebVmToGuarantorMapping;
                Object.keys(lebVmToGuarantorMapping).forEach(key => {
                    try{
                        eval(`if(!guarantorData.TmxGuarantor.${lebVmToGuarantorMapping[key]}) guarantorData.TmxGuarantor.${lebVmToGuarantorMapping[key]} = vm[key]`);
                    } 
                    catch(e){
                        console.log("error in evaluating guarantor mapping");
                    }
                });
            }

        }
        function checkUniqueClients() {
            if (exists(vm.dialogForm, '$error.required') && vm.newCustomer) { // only checking required because unique clients might be done in arabic
                ToastService.showCustomToast("default", $filter('translate')("FillRequiredFields"));
                return;
            }
            disableAddBtn = GuarantorETBMandatory;
            vm.negcustomer = 0;
            vm.reasonsList = null;
            var defaultValue = (vm.isVitasIraqTenant ? "" : null);
            var uniqueClientJson = vm.isLebanonTenant ? {
                "NewDataSet": {
                    "Table": {
                        "FirstName": vm.FirstName,
                        "MiddleName": vm.MiddleName,
                        "LastName": vm.LastName,
                        "MotherName": vm.MotherName,
                        "EnglishName": vm.EnglishName,
                        "CDRFirstName": vm.CdrFirstName,
                        "CDRFatherName": vm.CdrFatherName,
                        "CDRMotherName": vm.CdrMotherName,
                        "CDRFamilyName": vm.CdrFamilyName,
                        "BirthDate": vm.BirthDate
                    },
                    "IDsList": vm.IDsList
                }
            } : {
                "NewDataSet": {
                    "Table": {
                        "UserId": vm.UserId,
                        "ClientID": vm.ClientID,
                        "EntityID": vm.EntityID,
                        "EntityTypeID": vm.EntityTypeID,
                        "IsReference": vm.IsReference,
                        "FirstName": vm.FirstName || defaultValue,
                        "FatherName": vm.FatherName || defaultValue,
                        "GrandfatherName": vm.GrandfatherName || defaultValue,
                        "LastName": vm.LastName || defaultValue,
                        "BirthDate": vm.BirthDate || defaultValue,
                        "ID": vm.ID,
                        "CompanyName": vm.CompanyName,
                        "MotherName":vm.MotherName || defaultValue
                    },
                    "IDsList": vm.IDsList
                }
            }

            tmxResource('Integration').getByAction('GetUniqueClients', false, 'post', uniqueClientJson).then(function (response) {
                if (response.data.WADataRootResult) {
                    vm.uniqueCustomersList = response.data.WADataRootResult.Table;
                    disableAddBtn = vm.uniqueCustomersList.length > 0 && GuarantorETBMandatory;
                }
                if(vm.isLebanonTenant){
                    if(tmxUtility.exists(vm.uniqueCustomersList) && vm.uniqueCustomersList.length > 0){
                        let blacklistedRecords= vm.uniqueCustomersList.filter(x=>(tmxUtility.exists(x.Reason) && x.Reason.toLowerCase().includes("blacklist") ))
                            .map(y=>y.Reason);
                        if(tmxUtility.exists(blacklistedRecords) && blacklistedRecords.length > 0){
                            vm.negcustomer = 1;
                            vm.reasonsList = blacklistedRecords.join(',');
                        }  
                    }
                }
            })
        }

        function TranslateModelValues() {
            var lebTranslationModelMapping = LoanApplicationService.lebTranslationModelMapping;
            var requestModel = {};
            Object.keys(lebTranslationModelMapping).forEach(key => {
                requestModel[lebTranslationModelMapping[key]] = vm[key];
            });
            tmxResource('Integration').getByAction('TranslateModelValues', false, 'post', requestModel).then(function (response) {
                if (exists(response.data)) {
                    Object.keys(lebTranslationModelMapping).forEach(key => {
                        vm[key] = response.data[lebTranslationModelMapping[key]];
                    });
                }
            });

        }

        vm.getETB = function () {
            if (vm.idvalue) {
                disableAddBtn = GuarantorETBMandatory;
                let url = 'GetETB/' + vm.idvalue;
                if (vm.isSambaTenant) {
                    let identifierType = vm.IdentifierLkpValue || "";
                    url = url + "/" + identifierType;
                }
                tmxResource('Integration').getByAction(url, true, 'get').then(function (response) {
                    if (response.data.length > 0) {
                        vm.customerMasterList = angular.copy(response.data);
                        // vm.customerMasterList.sort(function(obj1, obj2) {

                        // if(obj1.TmxCustomerDetail.length > 0 && obj2.TmxCustomerDetail.length > 0)
                        // {
                        // 	var date1 = new Date(obj1.TmxCustomerDetail[0].RelationWithBanks);
                        // 	var date2 = new Date(obj2.TmxCustomerDetail[0].RelationWithBanks);

                        // 	if(date1 > date2) return -1;
                        // 	if(date1 < date2) return 1;

                        // }
                        // return 0;                                
                        // })
                    }
                    else {
                        disableAddBtn = false;
                    }
                })
            }
            else {
                ToastService.showCustomToast("default", "Please Enter NIC");
            }
        }

        vm.onIdentifierTypeChange = function (IdentifierTypeValue) {

            if (IdentifierTypeValue) {
                vm.IDValueMaxLength = findIdentifierTypeMaxLength(IdentifierTypeValue);
            }
            else {
                vm.IDValueMaxLength = null;
            }
        }

        function findIdentifierTypeMaxLength(typeId) {
            if (tmxUtility.exists(typeId)) {
                var lookup = lookupService.getLookupById(typeId);
                return tmxUtility.exists(lookup) ? lookup.LookupName : null;
            }
            return null;
        }

        //#endregion =======================================================================


        //#region  ================== Page Setup Logic =======================================

        function PopulateConfigurations() {
            if (LoggedInUserConfigurations) {
                vm.loginTenantName = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'INTEGRATION_TENANT').toLowerCase();

            }
        }
        function SetupData() {
            if ($scope.applicationData) {
                vm.applicationData = $scope.applicationData;
                vm.productId = $scope.applicationData.ProductId || $scope.applicationData.LoanProductId;

            }
            if ($scope.status) {
                vm.applicationStatus = $scope.status;
            }

            for (var i = 0; i < $scope.page.fieldMap.all.length; i++) {
                var field = $scope.page.fieldMap.all[i];
                if (field && (field.type == 'checkbox_file' || field.type == 'fingerprint')) {
                    vm.checklist.push(field);
                }
            }
        }
        function applicationDataInitialize() {
            if ($scope.applicationData && $stateParams.Id != '-1') {
                vm.cnicLookupId;
                var data = lookupService.getLocalLookupsByType(lkupType.ID_TYPE);
                if (data) {
                    data.filter(function (item) {
                        if (item.VisibleValue == "NIC Number (ID-N)")
                            vm.cnicLookupId = item.LookupId;
                    });
                }

                if (vm.loginTenantName == tenants.UBANK) {
                    vm.guarantorData = $scope.applicationData.TmxLoanAppToGuarantorMpg;
                }
                if (vm.loginTenantName != tenants.UBANK) {
                    if (!exists($scope.applicationData.TmxLoanApplicationToGuarantorMapping)) {
                        $scope.applicationData.TmxLoanApplicationToGuarantorMapping = [];
                    }

                    vm.guarantorData = $scope.applicationData.TmxLoanApplicationToGuarantorMapping;
                }

                if ($scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && $scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson) {
                    if (angular.isDefined($scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) && $scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail != null && angular.isDefined($scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]))
                        vm.NameOfEmployer = $scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                    if (angular.isDefined($scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) && $scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail != null && angular.isDefined($scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]))
                        vm.NatureOfBusiness = $scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness;
                    vm.cnicData = $scope.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                        return item.NationalIdTypeLkp == vm.cnicLookupId;
                    })[0];
                }
                if (angular.isDefined(vm.guarantorData) && angular.isDefined(vm.guarantorData[0])) {
                    vm.guarantorId = vm.guarantorData[0].GuarantorId;

                }
                if (angular.isDefined(vm.cnicData))
                    vm.cnic = vm.cnicData.NationalIdentifierValue;
                //CurAddressLine3UDF
                if (angular.isDefined($scope.applicationData.TmxCustomerMaster) && angular.isDefined($scope.applicationData.TmxCustomerMaster[0]))
                    vm.areaCode = $scope.applicationData.TmxCustomerMaster[0].PerAddressLine3UDF;
                if ($scope.applicationData.TmxCustomerMaster[0].FRMUStatus == "Cleared")
                    vm.cleared = true;
                if ($scope.applicationData.TmxCustomerMaster[0].FRMUStatus == "BlackListed")
                    vm.blackListed = true;

                if (tmxUtility.exists($scope.applicationData.TmxProduct)) {
                    let tmxProductObj = $scope.applicationData.TmxProduct;
                    if (Array.isArray(tmxProductObj)) {
                        tmxProductObj = $scope.applicationData.TmxProduct[0];
                    }
                    let productTypeLkp = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.Product);
                    let productTypeLookupItem = productTypeLkp.find(x => x.LookupId == tmxProductObj.ProductTypeLkp);
                    if (tmxUtility.exists(productTypeLookupItem)) {
                        if (productTypeLookupItem.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.AccountProduct) {
                            vm.productTypeCode = 'A';
                        }
                        else if (productTypeLookupItem.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.TradeProduct) {
                            vm.productTypeCode = 'T';
                        }
                        else {
                            vm.productTypeCode = 'L';
                        }
                    }
                }
            }
        }
        function CheckAndInitializeGuarantorTab() {
            if (hasGuarantorTabAsChild) { // If the guarantor is in the child tabs of the page
                vm.guarantorTabEditPrivilege = vm.checkPermission('Guarantors', 'Edit');
                vm.guarantorTabDeletePrivilege = vm.checkPermission('Guarantors', 'Delete');
                SetGuarantorVisiblity();
                if (LoggedInUserConfigurations) {
                    vm.guarantorAttach = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SHOW_GUARANTOR_ATTACH_OPTION').toLowerCase();
                    vm.isGuarantorDynamic = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_GUARANTOR_DYNAMIC', true, vm.productId) == true;
                    GuarantorETBMandatory = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'IS_GUARANTOR_ETB_MANDATORY', true) == true;

                    if (GuarantorETBMandatory) {
                        GuarantorETBMandatory = true;
                        disableAddBtn = true;
                    }
                }
                vm.addIdentificationDocumentNumber(0);
            }
            if ($scope.page.defaultValue == guarantorPageDefaultValue) { // If the page itself is Guarantor Page
                vm.guarantorTabEditPrivilege = vm.checkPermission('Guarantors', 'Edit');
                vm.guarantorTabDeletePrivilege = vm.checkPermission('Guarantors', 'Delete');
            }
        }
        function SetGuarantorVisiblity() {
            vm.showGuarantor = true;
            if (vm.loginTenantName == tenants.VITAS_LEB && exists($scope.applicationData)) {
                var productId = exists($scope.applicationData.ProductId) ? $scope.applicationData.ProductId : $scope.applicationData.LoanProductId;
                if (exists(productId) && productId > 0) {
                    vm.showGuarantor = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'SHOW_GUARANTOR_TAB', true, productId);
                }
            }
        }
        function InitializeDynamicTab() {
            if (exists($scope.page.tabs) && $scope.page.tabs.length > 0) {
                var index = 1;
                var rightDirection = false;
                if (vm.direction == "rtl") {
                    index = $scope.page.tabs.length;
                    rightDirection = true;
                }
                $scope.page.tabs.forEach(function (tab) {

                    tab.title = index + " - " + tab.title;
                    if (rightDirection) {
                        index = index - 1;

                    }
                    else {
                        index = index + 1;
                    }
                    if (tab.defaultValue == guarantorPageDefaultValue) {
                        hasGuarantorTabAsChild = true;
                        guarantorTabSchema = dynamicFormService.pageSchema.Tabs.find(x => x.TabId == tab.id);
                        guarantorTabSchema.ProductId = vm.productId;
                        tab.skipTabInPageValidation = true; // Exclude guarantor tab in page validation because the guarantor popup would already have been validated.
                    }
                    tab.pageData.fields.forEach(function (field) {
                        initField(field, vm.map, $scope);
                    });
                });
            }
            vm.tnameMap = $scope.page.fieldMap.tname;
            vm.table = makeTable($scope.page.config.cols, $scope.page.pageData.fields, function (field) {
                initField(field, vm.map, $scope);
            });
            if (!angular.isDefined($scope.disabled)) {
                $scope.disabled = false;
            }
            if ($scope.disabled) {
                $scope.page.istabDisabled = $scope.disabled;
                $scope.page.tabs.forEach(tab => { tab.istabDisabled = $scope.disabled; });
            }
            $scope.page.istabDisabled = $scope.page.istabDisabled || false;
        }

        function SetPageVariables() {
            vm.hasTitle = exists($scope.page.title) && $scope.showTitle == "true";
            vm.hasFields = exists($scope.page.pageData.fields) && exists($scope.page.pageData.fields.find(x => x.visibility.value));
            vm.hasTabs = exists($scope.page.tabs) && $scope.page.tabs.length > 0;
        }
        function TenantSpecificCases() {
            IdlookupType = 'ID Type'; // Default case
            // if (vm.loginTenantName == tenants.SILK) {
            //     if (!dynamicFormService.applicationData.TmxCustomerMaster[0].EcibFetchFlag && $scope.page.tabs.length == 0) {
            //         $scope.page.istabDisabled = true;
            //         $scope.disabled = true;
            //     }
            //     else {
            //         $scope.page.istabDisabled = false;
            //         $scope.disabled = false;
            //     }
            // }
            if (tenants.VITAS == vm.loginTenantName) {
                vm.showJorUniqueClient = true;
                vm.isJordanTenant = true;
                IdlookupType = 'IdentificationDocumentTypesStaticPage';

            }
            else if (tenants.VITAS_EG == vm.loginTenantName) {
                vm.showJorUniqueClient = true;
                vm.isVitasEgyptTenant = true;
                IdlookupType = 'IdentificationDocumentTypesStaticPage';

            }
            else if(tenants.VITAS_IRQ == vm.loginTenantName) {
                vm.showJorUniqueClient = true;
                vm.isVitasIraqTenant = true;
                IdlookupType = 'IdentificationDocumentTypes';
            }
            else if (tenants.VITAS_LEB == vm.loginTenantName) {
                vm.isLebanonTenant = true;
                IdlookupType = 'IdentificationDocumentTypes';

            }
            else if (tenants.UBANK == vm.loginTenantName) {
                vm.showUbank = true;
            }
            else if (tenants.SAMBA == vm.loginTenantName) {
                vm.isSambaTenant = true;
                vm.isGuarantorDynamic = true;
            }


            lookupService.getLookupByType(IdlookupType).then(function (response) {
                if (response) {
                    vm.IdentifierLkp = angular.copy(response);
                }
            });
        }

        (function InitializePage() {
            PopulateConfigurations();
            SetupData();
            TenantSpecificCases();
            applicationDataInitialize();
            InitializeDynamicTab();
            CheckAndInitializeGuarantorTab();
            SetPageVariables();
        })();

        //#endregion==========================================================================


    }


    function initField(field, map, scope) {
        if (exists(field.conditionalRequired))
            initConditionalIsRequried(field, map, scope); //initialize conditional required
        if(exists(field.isDisabled) && field.isDisabled.isExpression == true && field.isDisabled.variables.length > 0) {
            initConditionalIsDisabled(field, map, scope);
        }
        if(exists(field.visibility) && field.visibility.isExpression == true && field.visibility.variables.length > 0) {
            initConditionalIsVisible(field, map, scope);
        }
    }

    function initConditionalIsVisible(field, map, scope) {
        try {
            function get() {
                return field.visibility.func(map, field.locals);
            }

            function updateVisibility(_new, _old) {
                if (_new != _old) {
                    if (_new) {
                        field.visibility.value = true;
                    }
                    else {
                        field.visibility.value = false
                    }
                }
            }
            updateVisibility(get()); //initilize
            scope.$watch(get, updateVisibility); //watch for future
        }
        catch (e) {
            console.log('Visibilty Formula Execution Error on:' + field.id, field.visibility.expression);
        }
    }

    function initConditionalIsDisabled(field, map, scope) {
        try {
            function get() {
                return field.isDisabled.func(map, field.locals);
            }

            function updateDisable(_new, _old) {
                if (_new != _old) {
                    if (_new) {
                        field.isDisabled.value = true;
                    }
                    else {
                        field.isDisabled.value = false
                    }
                }
            }
            updateDisable(get()); //initilize
            scope.$watch(get, updateDisable); //watch for future
        }
        catch (e) {
            console.log('Disabled Formula Execution Error on:' + field.id, field.isDisabled.expression);
        }
    }

    function initConditionalIsRequried(field, map, scope) {
        try {
            function get() {
                return field.conditionalRequired.func(map, field.locals);
            }

            function updateRequired(_new, _old) {
                if (_new != _old) {
                    if (_new) {
                        field.setValidation("required", "true");
                    }
                    else {
                        field.setValidation("required", "false");
                    }
                }
            }
            updateRequired(get()); //initilize
            scope.$watch(get, updateRequired); //watch for future
        }
        catch (e) {
            console.log('Required Formula Execution Error on:' + field.id, field.validations.required);
        }
    }

    // eslint-disable-next-line no-unused-vars
    function evalFormula(field, keyMap) {
        var formula = field.formula;
        if (!exists(formula, "expression") || formula.expression.length == 0) return 0;
        //var result= getValueFromField(keyMap["tf138"]) - getValueFromField(keyMap["tf147"]) +getValueFromField(keyMap["tf149"]) + getValueFromField(keyMap["tf150"]) +getValueFromField(keyMap["tf151"]) + getValueFromField(keyMap["tf153"]) +getValueFromField(keyMap["tf155"]) + getValueFromField(keyMap["tf157"]) - getValueFromField(keyMap["tf160"]) - getValueFromField(keyMap["tf161"]) - getValueFromField(keyMap["tf162"]) - getValueFromField(keyMap["tf163"]) - getValueFromField(keyMap["tf164"]) - getValueFromField(keyMap["tf165"]) - getValueFromField(keyMap["tf166"]) - getValueFromField(keyMap["tf167"]) - getValueFromField(keyMap["tf168"]) - getValueFromField(keyMap["tf169"]) - getValueFromField(keyMap["tf170"]) ;
        var result = formula.func(keyMap, field.locals);
        return result;
    }

    // eslint-disable-next-line no-unused-vars
    function getValueFromField(field) {
        var result = parseInt(field.value);
        if (isNaN(result)) return 0;
        return result;
    }

    function makeTable(colsize, array, forEachField) {
        var table = [];
        var row = [];
        for (var i = 0; i < array.length; i++) {
            forEachField(array[i]);
            if (row.length < colsize) {
                if (shouldOccypySingleRow(array[i])) {
                    if (row.length > 0) {
                        table.push(fillToFit(row, colsize));
                        row = [];
                    }
                    table.push([array[i]]); //only thing in a row
                }
                else {
                    row.push(array[i]);
                }
            }
            else {
                table.push(row);
                if (shouldOccypySingleRow(array[i])) {
                    table.push([array[i]]);
                    row = [];
                }
                else
                    row = [array[i]];
            }
        }
        if (row.length > 0) {
            table.push(fillToFit(row, colsize));
        }
        return table;
    }

    function shouldOccypySingleRow(field) {
        return field.type == 'table' || field.type == 'header' || field.type == 'textarea' || field.type == 'checkbox_file' || field.type == 'htmlarea';
    }

    function fillToFit(row, colsize) {
        while (row.length !== colsize) {
            row.push({
                type: "dummy"
            });
        }
        return row;
    }


    angular.module('tmx-app').directive('tmxHelpBox', tmxHelpBox);

    function tmxHelpBox() {
        var directive = {
            scope: {
                show: "=",
                field: "="
            },
            restrict: 'E',
            templateUrl: 'common/directives/dynamicpage/tmxhelpbox.html',
            link: tmxHelpBoxCtrl
        };

        function tmxHelpBoxCtrl($scope) {
            $scope.isCustomViolation = isCustom;
            $scope.extractMessage = extractMessage;
        }

        function isCustom(violation) {
            return violation.indexOf("custom:") > 0;
        }

        function extractMessage(customViolation) {
            return customViolation.substring(customViolation.indexOf("custom:"));
        }
        return directive;
    }

})();